// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"4726e9e2","412":"d5052514","718":"183ef168","807":"3063995f"}[chunkId] + ".chunk.js";
};